import * as React from 'react'
import Spinner from '../components/Spinner'
import moment from 'moment/min/moment-with-locales'
import { Link } from 'react-router-dom'

class AddedFishListScreen extends React.Component {


  componentDidMount() {
    if( !this.props.fish.addedFish )
      this.props.getAddedFishList()
  }


  render() {
    const { addedFish } = this.props.fish
    
    if( this.props.app.loading ) return <Spinner />
    if( !addedFish ) return <Spinner />
    
    return (
      <div>
      <div className="alert alert-info">Tutaj możesz edytować ryby dodane na targ w ciągu ostatnich 12h</div>

      { !addedFish.length && <div className="alert alert-primary">Brak dodanych w ciągu ostatnich 12h</div>}

      <table className="table table-striped">
        <tbody>
          {addedFish.map( (fish, key) => {
            let fishName = this.props.fish.fishTypes.filter(f => f.id===fish.fishType)[0]
            
            
            return (
            <tr key={key}>
              <td>
                <Link 
                  key={key}
                  className="list-group-item"
                  to={{
                    pathname: 'add-fish',
                    fish
                  }}
                >
                  <div className="row">
                    <div className="col-md-12">
                      <span>{fishName.name}, </span>
                      <span>{fish.amount} {fishName.amount.kg ? 'kg' : 'szt.'}, </span>
                      <span>{moment(fish.time.seconds*1000).format("YYYY-MM-DD, H:mm")} </span>
                    </div>
                  </div>
                </Link>
              </td>
            </tr>  
          )} )}
        </tbody>
      </table>
    </div>
    )
  }
}


export default AddedFishListScreen



// WEBPACK FOOTER //
// ./src/screens/AddedFishListScreen.js